module.exports = __webpack_public_path__ + "img/22.83c0e917.png";